export const GET_COLLECTION_DETAILS = "/v1/reports/collection-detail";
export const GET_SCHOOL_DETAILS = "/v1/reports/school-detail";
export const GET_COLLETION_DOWNLOAD_EXCEL = "/v1/reports/collection-detail/download";
export const GET_SCHOOLDETAILS_DOWNLOAD_EXCEL = "/v1/reports/school-detail/download";